export const stockUnitsContants = {
  GET_ALL_STOCK_UNITS: "GET_ALL_STOCK_UNITS",
};
